enum _3DModelFormat {
    PLY = "PLY",
    GLTF = "GLTF",
  }
  
  export default _3DModelFormat;